import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Button, Container, Dimmer, Form, Icon, Loader } from 'semantic-ui-react';
import store from '../../store';
import './warehouse.scss';

const mapStateToProps = (state: any) => {
  return {
    provider: state.provider
  }
}

function WarehouseComponent(props: any) {

    const history = useHistory()
    const location = useLocation()

    useEffect(() => {
        var token = localStorage.getItem('providerToken')
        if (token && token !== 'undefined') {
            getWarehouse();
        }
        else {
            console.log("Will redirect to: " + window.location.pathname)
            store.dispatch({ type: "redirectUrl", data: window.location.pathname })
            history.push("/")
        }
    }, []);

    const [originalWarehouse, setOriginalWarehouse] = useState({ id: null, name: "", count: 0, minCount: 0, slug: ""});
    const [warehouse, setWarehouse] = useState({ id: null, name: "", count: 0, minCount: 0, slug: ""});
    const [fetchedDetails, setFetchedDetails] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [successMsg, setSuccessMsg] = useState("");
    const [accumulatedAdd, setAccumulatedAdd] = useState(0);

    const getWarehouse = () => {
        var token = localStorage.getItem('providerToken')
        if (!token || token === 'undefined') {
            console.log("Will redirect to: " + window.location.pathname)
            store.dispatch({ type: "redirectUrl", data: window.location.pathname })
            history.push("/provider-login")
            return;
        }

        fetch(process.env.REACT_APP_API_URL + 'provider/warehouse/' + props.match.params.id, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': token,
                'Content-Type': 'application/json'
            }
        }).then((res: any) => {
            if (res.ok) {
                res.json().then((resJson: any) => {
                    if (resJson?.warehouse?.id) {
                        setOriginalWarehouse(Object.assign(originalWarehouse, resJson.warehouse))
                        setWarehouse(resJson.warehouse);
                    }
                    setFetchedDetails(true);
                })
            }
        }).catch(err => {
            console.error(err)
        })
    }

    const changeHandler = (e: any) => {
        if (e.target.name === 'count') {
            const newValue = parseInt(e.target.value) || 0;
            const newAccumulated = newValue - warehouse.count;
            setAccumulatedAdd(newAccumulated);
        } else {
            setWarehouse({ ...warehouse, [e.target.name]: e.target.value })
        }
    }

    const addToCount = (amount: number) => {
        setAccumulatedAdd(prev => prev + amount);
    }

    const resetAccumulated = () => {
        setAccumulatedAdd(0);
    }

    const save = () => {
        var token = localStorage.getItem('providerToken')

        if (token && token !== 'undefined') {

            let payload = { id: warehouse.id, count: warehouse.count + accumulatedAdd, minCount: warehouse.minCount }

            setLoading(true)

            fetch(process.env.REACT_APP_API_URL + 'provider/warehouse/count', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            })
            .then((res: any) => {
                setLoading(false)
                if (!res.ok) {
                    setErrorMsg("Сүлжээнд алдаа гарлаа")
                }
                else {
                    setErrorMsg("")
                    setSuccessMsg("Амжилттай хадгаллаа")
                    // Update warehouse count with accumulated additions
                    setWarehouse({ ...warehouse, count: warehouse.count + accumulatedAdd })
                    setAccumulatedAdd(0)
                    setTimeout(() => {
                        setSuccessMsg("")
                    }, 3000);
                }
            })
            .catch(err => {
                setLoading(false)
                setErrorMsg("Сүлжээний алдаа")
                console.error(err)
            })
        }
    }

    const getBackUrl = () => {
        const urlParams = new URLSearchParams(location.search);
        const from = urlParams.get('from');
        const barcode = urlParams.get('barcode');
        
        if (from === 'shelf' && barcode) {
            return `/provider/shelf?search=${barcode}`;
        } else if (from === 'products') {
            return '/provider/warehouse';
        } else {
            return '/provider/warehouse';
        }
    }

    return (
        <div className="page margin-top-50-sm">
            <Container>
                <Dimmer active={loading}>
                    <Loader size='medium'></Loader>
                </Dimmer>

                <div className="flex-div width-100">
                    {!fetchedDetails ? null :
                        <section className="warehouse-form" id="my-form">
                            <div className="form-group">
                                <Link to={getBackUrl()}><Icon name="arrow left"/>
                                    <span className="underline">Буцах</span>
                                </Link>
                            </div>
                            <div className="form-group">
                                <Link className="underline" to={"/provider/warehouse-actions/" + warehouse.id}>Үлдэгдлийн түүх</Link>
                            </div>
                            <div className="form-group">
                                <div className="label">
                                    <a className="underline" href={"/product/" + warehouse.slug} target="_blank">Худалдааны линк</a>
                                    <h2>{ warehouse.name }</h2>
                                </div>
                            </div>

                            <Form widths='equal'>
                                <div className="form-group">
                                    {errorMsg ? <div className="error-msg"><Icon name="warning circle"/>{errorMsg}</div> : null}
                                </div>
                                <div className="form-group">
                                    {successMsg ? <div className="success-msg"><Icon name="checkmark"/>{successMsg}</div> : null}
                                </div>
                                <div className="form-group">
                                    <div className="label">Үлдэгдэл:</div>
                                    <Form.Input type="number" required name="count" value={warehouse.count + accumulatedAdd} min={0} onChange={changeHandler} />
                                    <div className="count-controls">
                                        <Button.Group>
                                            <Button onClick={() => addToCount(1)}>+1</Button>
                                            <Button onClick={() => addToCount(10)}>+10</Button>
                                            <Button onClick={resetAccumulated} color="orange">
                                                <Icon name="close" />
                                            </Button>
                                        </Button.Group>
                                    </div>
                                    <div className="count-display">
                                        <div className="original-count" style={{color: 'red'}}>
                                            Анхны утга: {warehouse.count}
                                        </div>
                                        {accumulatedAdd > 0 && (
                                            <div className="new-count" style={{color: 'green'}}>
                                                Шинэ: {warehouse.count + accumulatedAdd} (+{accumulatedAdd})
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="label">Анхааруулах үлдэгдэл:</div>
                                    <Form.Input type="number" required name="minCount" value={warehouse.minCount} min={0} onChange={changeHandler} />
                                    <p><Icon name="info circle"/>Бүтээгдэхүүний үлдэгдэл хэмжээ нь тус хэмжээнээс бага болох үед танд имэйл илгээж мэдэгдэнэ</p>
                                </div>
                                <br/>
                                <div className="form-group">
                                    <Button className="width-100" color='red' onClick={() => save()} disabled={loading}>Хадгалах</Button>
                                </div>
                            </Form>
                        </section>
                    }
                </div>
            </Container>
        </div>
    );
}

export default connect(mapStateToProps)(WarehouseComponent)